//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import ecommerceIntegrationsStartTemplate from '@legacy-components/ecommerce-integrations/ecommerce-integrations-start.html';

(function() {
  angular.module('curalate').component('ecommerceIntegrationsStart', {
    bindings: {
      continueCallback: '&',
    },
    template: ecommerceIntegrationsStartTemplate,
  });
})();
